module.exports = __webpack_public_path__ + "img/CSS3.f9754205.png";